export const getContextToken = contextId => ({
  claims: ['wix.comments.CommentsAccess'],
  contextId,
  contextType: 'ForumPost',
});
